

import { BasicClientCommand } from "../BasicClientCommand";

export class PrivateOfferQuestDialogClientCommand extends BasicClientCommand {
    public execute(commandVars: any = null): void {
        return;
    }
}

